<div data-testid="login-login-wrapper" class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">

    <div data-testid="login-widget" class="dx-widget">
      <div data-testid="login-logo" class="logo">
        <h2><span style="font-weight: 700;">CREDIT</span>HUB</h2>
      </div>
      <div data-testid="login-login-user" class="login-user">
        <h3>Welcome</h3>
      </div>



        <div data-testid="login-input-btn" class="input-btn mt-4">
          <dx-button data-testid="login-btn" class="btn btn-primary btn-login" style="width: 160px;" (onClick)="onSubmit()">Log in</dx-button>
        </div>



      <div data-testid="login-legal-notice" class="legal-notice">
        <a href="https://mountstreet.com/privacy-policy" target="_blank">Privacy Policy</a>
        <a href="https://mountstreet.com/terms-and-conditions" target="_blank">Terms and Conditions</a>
        <a href="https://mountstreet.com/cookie-policy" target="_blank">Cookie Policy</a>
        <a href="https://mountstreet.com/acceptable-use-policy/" target="_blank">Acceptable Use Policy</a>
      </div>
    </div>
  </div>